/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_Invalid_AssigneeInputs */

const en_task_settings_invalid_assignee = /** @type {(inputs: Task_Settings_Invalid_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an enabled person with an eligible profile. Named document assignees must be internal staff.`)
};

const pt_br2_task_settings_invalid_assignee = /** @type {(inputs: Task_Settings_Invalid_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma pessoa ativa com um perfil elegível. Responsáveis nomeados por documentos devem ser da equipe interna.`)
};

/**
* | output |
* | --- |
* | "Select an enabled person with an eligible profile. Named document assignees must be internal staff." |
*
* @param {Task_Settings_Invalid_AssigneeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_invalid_assignee = /** @type {((inputs?: Task_Settings_Invalid_AssigneeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_Invalid_AssigneeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_invalid_assignee(inputs)
	return pt_br2_task_settings_invalid_assignee(inputs)
});